import meter1 from "../assets/img/meter1.svg";
import meter2 from "../assets/img/meter2.svg";
import meter3 from "../assets/img/meter3.svg";
import meter4 from "../assets/img/meter4.svg";
import meter5 from "../assets/img/meter5.svg";
import meter6 from "../assets/img/meter6.svg";
import meter7 from "../assets/img/meter7.svg";

import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
//import arrow1 from "../assets/img/arrow1.svg";
//import arrow2 from "../assets/img/arrow2.svg";
import colorSharp from "../assets/img/color-sharp.png"

export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
    <section className="skill" id="skills">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="skill-bx wow zoomIn">
                        <h2>Skills</h2>
                       <br></br> 
                        <Carousel responsive={responsive} infinite={true} className="owl-carousel owl-theme skill-slider">
                        <div className="item">
                                <img  alt="jjlxx"src={meter1} />
                                <h5>HTML</h5>
                            </div>
                            <div className="item">
                                <img  alt="jjlss" src={meter2}  />
                                <h5>JAVA SCRIPT</h5>
                            </div>
                            <div className="item">
                                <img  alt="jjdddl"src={meter3} />
                                <h5>REACT JS</h5>
                            </div>
                            <div className="item">
                                <img  alt="jjlxx"src={meter4} />
                                <h5>TAILWIND CSS</h5>
                            </div>
                            <div className="item">
                                <img  alt="jjlxx"src={meter5} />
                                <h5>REDUX</h5>
                            </div>
                            <div className="item">
                                <img  alt="jjlxx"src={meter6} />
                                <h5>GITHUB</h5>
                            </div>
                            <div className="item">
                                <img  alt="jjlxx"src={meter7} />
                                <h5>FIREBASE</h5>
                            </div>
                            


                        </Carousel>
                    </div>
                </div>
            </div>
        </div>
        <img className="background-image-left" src={colorSharp} alt="Imagex" />
    </section>
  )
}
